/**
 * A Code 128 barcode with its human-readable text underneath.
 *
 * The SVG comes from domain/barcode.js, which builds it from the value alone —
 * digits and ASCII, never markup — so injecting it is safe. Black on white in
 * every theme: a scanner needs contrast, not a palette.
 */

import { useMemo } from 'react';
import { code128Svg } from '../../domain/barcode';

export function Barcode({ value, height = 52, module = 1.6, className = '', showText = true }) {
  const svg = useMemo(() => {
    try {
      return value ? code128Svg(String(value), { height, module }) : null;
    } catch {
      return null;
    }
  }, [value, height, module]);

  if (!svg) return null;
  return (
    <div className={`barcode inline-flex flex-col items-center ${className}`} dir="ltr">
      <div className="barcode__bars" dangerouslySetInnerHTML={{ __html: svg }} />
      {showText && <span className="barcode__text">{String(value).replace(/(\d{2})(\d{4})(\d{6})(\d)/, '$1 $2 $3 $4')}</span>}
    </div>
  );
}

export default Barcode;
